// import i18n from '@/i18n/index'

export default {
  basicInformation: [{
    prop: 'prize'
  }, {
    prop: 'name'
  }, {
    prop: 'prizeable'
  }, {
    prop: 'image',
    image: true
  }, {
    prop: 'status',
    back: true
  }, {
    prop: 'created_at'
  }, {
    prop: 'updated_at'
  }]
}
